import React, { FC } from 'react';
import { useLocalizationContext } from '../../lib/localization';
import {
    AppStoreEn,
    AppStoreDe,
    AppStoreEsMx,
    AppStoreFr,
    AppStoreEs,
    AppStoreIt,
    AppStoreJa,
    AppStorePl,
    AppStorePtBr,
    AppStoreRu,
    AppStoreZhHant,
} from '.';

export const LanguageImage: FC = () => {
    const { language } = useLocalizationContext();

    const imageMap: Record<string, JSX.Element> = {
        en: <AppStoreEn />,
        de: <AppStoreDe />,
        es: <AppStoreEs />,
        'es-MX': <AppStoreEsMx />,
        fr: <AppStoreFr />,
        it: <AppStoreIt />,
        ja: <AppStoreJa />,
        pl: <AppStorePl />,
        'pt-BR': <AppStorePtBr />,
        ru: <AppStoreRu />,
        'zh-Hans': <AppStoreZhHant />,
        'zh-Hant': <AppStoreZhHant />,
    };

    const selectedImage = imageMap[language] ?? imageMap.en;

    return <>{selectedImage}</>;
};
